export const findDuplicates = <T>(arr: T[]) =>
  arr.reduce((acc: typeof arr, el, i, initArr) => {
    if (initArr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el);
    return acc;
  }, []);
